export default __webpack_public_path__ + "static/media/flower.61fe80dc.svg";